"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgChannelWhatsApp = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgChannelWhatsApp = function SvgChannelWhatsApp(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#sc_wa__paint0_linear)",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M102.999 59.892c0 23.137-18.9 41.893-42.218 41.893a42.29 42.29 0 01-20.34-5.176.192.192 0 00-.142-.017l-19.994 5.326a.192.192 0 01-.236-.227l4.534-20.092a.192.192 0 00-.024-.142 41.45 41.45 0 01-6.018-21.565C18.561 36.755 37.463 18 60.781 18c23.32 0 42.218 18.755 42.218 41.892zm-42.218-35.22c-19.574 0-35.495 15.8-35.495 35.22 0 7.673 2.49 14.782 6.706 20.574a.192.192 0 01.03.166l-3.428 12.034a.192.192 0 00.238.237l12.336-3.591a.192.192 0 01.159.023 35.472 35.472 0 0019.455 5.778c19.57 0 35.495-15.798 35.495-35.219 0-19.42-15.924-35.223-35.496-35.223zM82.1 69.54c-.262-.427-.95-.685-1.984-1.198-1.036-.513-6.126-2.998-7.072-3.34-.948-.341-1.64-.513-2.33.514-.688 1.028-2.672 3.34-3.277 4.024-.604.688-1.207.773-2.243.26-1.033-.514-4.367-1.6-8.32-5.096-3.076-2.722-5.154-6.082-5.758-7.11-.603-1.028-.063-1.583.454-2.094.467-.461 1.036-1.2 1.553-1.799.519-.6.69-1.027 1.034-1.713.347-.685.174-1.284-.086-1.8-.258-.513-2.33-5.566-3.192-7.622-.862-2.054-1.723-1.712-2.327-1.712-.603 0-1.294-.086-1.984-.086s-1.812.257-2.76 1.284c-.949 1.028-3.621 3.513-3.621 8.565 0 5.053 3.706 9.935 4.225 10.619.517.684 7.157 11.39 17.678 15.502 10.521 4.11 10.521 2.738 12.42 2.566 1.895-.17 6.12-2.483 6.986-4.88.86-2.4.86-4.455.603-4.884z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "sc_wa__paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: 0.167,
    stopColor: "#46ED63"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#1FC940"
  }))));
};

exports.SvgChannelWhatsApp = SvgChannelWhatsApp;